/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement } from 'react';
import { BoxProps, Tr } from '@wegroup/design-system';
import { flexRender, Row, Cell } from '@tanstack/react-table';
import ReactTableBodyCell from '../ReactTable/ReactTableBodyCell';

interface CustomColumnProps {
  isSticky?: boolean;
  dependencies?: string[];
}

interface Props<TData> {
  row: Row<TData>;
  isScrollable: boolean;
  spannedCellRenderer: (value: unknown) => ReactElement;
  onClick?: () => void;
  getRowSx?: (row: Row<TData>) => BoxProps['sx'];
}

const ReactTableV8BodyRow = <TData,>({
  row,
  isScrollable,
  spannedCellRenderer,
  onClick,
  getRowSx,
}: Props<TData>) => {
  const isClickable = !!onClick;
  const lastCell = row.getVisibleCells()[row.getVisibleCells().length - 1];
  const lastCellMeta = lastCell?.column.columnDef.meta as
    | CustomColumnProps
    | undefined;
  const isLastCellSticky = !!lastCellMeta?.isSticky && isScrollable;

  return (
    <>
      <Tr
        cursor={isClickable ? 'pointer' : 'inherit'}
        onClick={onClick}
        sx={getRowSx ? getRowSx(row) : undefined}
        _hover={
          isClickable
            ? { 'td, #REACT_TABLE_HOVER_ELEMENT': { bg: 'gray.ultraLight' } }
            : {}
        }
      >
        {row.getVisibleCells().map((cell) => {
          const columnMeta = cell.column.columnDef.meta as
            | CustomColumnProps
            | undefined;
          const isStickyColumn = !!columnMeta?.isSticky && isScrollable;
          const dependencies = columnMeta?.dependencies?.map(
            (val) => (row.original as Record<string, unknown>)[val],
          );

          return (
            <ReactTableBodyCell
              key={cell.id}
              isSticky={isStickyColumn}
              dependencies={dependencies || undefined}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </ReactTableBodyCell>
          );
        })}
      </Tr>
    </>
  );
};

export default ReactTableV8BodyRow;
